var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5530",
    "data-name": "Group 5530",
    transform: "translate(-15114 -10119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3738",
    "data-name": "Group 3738",
    transform: "translate(14967.5 9837)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M12.6.869,9.549,7.333,2.722,8.373a1.582,1.582,0,0,0-.827,2.666l4.939,5.029-1.168,7.1a1.509,1.509,0,0,0,2.168,1.645l6.107-3.354,6.107,3.354a1.51,1.51,0,0,0,2.168-1.645l-1.168-7.1,4.939-5.029a1.582,1.582,0,0,0-.827-2.666l-6.827-1.04L15.282.869A1.469,1.469,0,0,0,12.6.869Z",
    transform: "translate(145.059 282.001)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star-2",
    "data-name": "Icon awesome-star",
    d: "M12.6.869c-.563.937-3.051,6.464-3.051,6.464L2.722,8.373a1.582,1.582,0,0,0-.827,2.666l4.939,5.029-1.168,7.1a1.509,1.509,0,0,0,2.168,1.645l6.107-3.354V.025A1.473,1.473,0,0,0,12.6.869Z",
    transform: "translate(15112.559 10118.978)",
    fill: "#fccd4f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStar);
export default __webpack_public_path__ + "static/media/half-star.41ffa8a3a0d709980a49078ade5bf6dd.svg";
export { ForwardRef as ReactComponent };